<template>
  <b-container class="px-0">
    <b-row class="mx-1">
      <b-col>
        <h3 class="text-dark">{{ $t('components.totals.subtotal') }}</h3>
      </b-col>
      <b-col cols="auto">
        <h3 v-if="showDonation" class="text-dark">{{ $n(order.subtotal - donationAmount, 'currency') }}</h3>
        <h3 v-else class="text-dark">{{ $n(order.subtotal, 'currency') }}</h3>
      </b-col>
    </b-row>
    <b-row v-if="discountAmount" class="mx-1">
      <b-col>
        <h3 class="text-dark">{{ $t('components.totals.discount') }}</h3>
      </b-col>
      <b-col cols="auto">
        <h3 class="text-dark">{{ $n(discountAmount, 'currency') }}</h3>
      </b-col>
    </b-row>
    <b-row v-if="order && order.shipping" class="mx-1">
      <b-col>
        <h3 class="text-dark">{{ order.shipping.name }}</h3>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="order.shipping.description" v-html="order.shipping.description"></div>
      </b-col>
      <b-col cols="auto">
        <h3 v-if="order.shipping && Number(order.shipping.fee) > 0" class="text-dark">{{ $n(order.shipping.fee, 'currency') }}</h3>
        <h3 v-else class="text-dark">{{ $t('components.totals.free') }}</h3>
      </b-col>
    </b-row>
    <b-row v-if="order && order.id && canUpgradeDowngradeShipping" class="mx-1">
      <b-col class="text-right">
        <a
          v-if="order.eligibleForPriorityTrackedShipping && order.shippingFeeOptions"
          href="javascript:void(0)"
          @click="upgradeToPriorityShipping"
        >
          {{ $t('components.totals.shipping.priority.upgradeText', [order.shippingFeeOptions[0].fee]) }}
        </a>
        <a v-else-if="canDowngradeToRegularShipping" href="javascript:void(0)" @click="downgradeToRegularShipping">
          {{ $t('components.totals.shipping.priority.downgradeText') }}
        </a>
      </b-col>
    </b-row>
    <b-row v-if="order.tax" class="mx-1">
      <b-col>
        <h3 class="text-dark">{{ $t('components.totals.tax', [tax.code, tax.rate]) }}</h3>
      </b-col>
      <b-col cols="auto">
        <h3 class="text-dark">{{ $n(order.tax, 'currency') }}</h3>
      </b-col>
    </b-row>
    <b-row v-if="order.processingFee" class="mx-1">
      <b-col>
        <h3 class="text-dark">
          {{ $t('components.totals.fees') }}
          <b-button id="fee-info" class="tooltip-btn" title="totals info">
            <fa-icon size="sm" :icon="['fas', 'info-circle']" class="tooltip-info" />
          </b-button>
          <b-tooltip target="fee-info" triggers="hover click blur" placement="right">
            {{ $t('components.totals.feesTip', [order.city.name]) }}
          </b-tooltip>
        </h3>
      </b-col>
      <b-col cols="auto">
        <h3 class="text-dark">{{ $n(order.processingFee, 'currency') }}</h3>
      </b-col>
    </b-row>
    <b-row v-if="showDonation" class="mx-1">
      <b-col>
        <h3 class="text-dark">
          {{ $t('components.totals.donation') }}
        </h3>
      </b-col>
      <b-col cols="auto">
        <h3 class="text-dark">{{ $n(donationAmount, 'currency') }}</h3>
      </b-col>
    </b-row>
    <hr />
    <slot name="above-total"></slot>
    <b-row class="mx-1">
      <b-col
        ><h2 class="font-weight-bold text-dark">{{ $t('components.totals.total') }}</h2></b-col
      >
      <b-col cols="auto">
        <h2 class="font-weight-bold text-dark">{{ $n(orderTotal, 'currency') }}</h2>
      </b-col>
    </b-row>
    <slot name="below-total"></slot>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    showDonation: {
      type: Boolean,
      required: false,
      default: false,
    },
    canUpgradeDowngradeShipping: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState({
      order: (state) => state.order.order,
    }),
    ...mapGetters({
      sections: 'order/getSections',
    }),
    donationAmount() {
      let amount = 0;
      this.sections.donations.forEach((donation) => {
        amount += donation.total;
      });
      return amount;
    },
    tax() {
      return {
        code: this.order.city.taxCode ? this.order.city.taxCode : '',
        number: this.order.city.taxNumber ? this.order.city.taxNumber : '',
        rate: this.order.city.taxRate ? this.order.city.taxRate : '',
      };
    },
    canDowngradeToRegularShipping() {
      return this.order?.canDowngradeToRegularShipping;
    },
    orderTotal() {
      return this.order?.total || 0;
    },
    discountAmount() {
      return Number(this.order?.discountAmountContext?.discountAmount);
    },
  },
  methods: {
    async upgradeToPriorityShipping() {
      await this.$store.dispatch('order/upgradeToPriorityShipping', this.order.id, { root: true });
    },
    async downgradeToRegularShipping() {
      await this.$store.dispatch('order/downgradeToRegularShipping', this.order.id, { root: true });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  svg#fee-info {
    opacity: 0.85;
  }
}
</style>
